import React from 'react'

export default function InfoBox({style, children}) {
  return (
    <div className={"mt-2 border-8 border-[#6b3b6d] p-1 text-sm flex flex-col justify-evenly w-28 h-28 bg-white drop-shadow-lg shadow-black " + style}>
        {children}
    </div>
  )
}
